import React from 'react'
import s from '@commonStyles/footer/Footer.module.scss'
import {AlfaRichContent as RichContent} from '@components/alfakher/pylot-rich-content'
import {Newsletter} from 'stores/ooka_usa_store/components/alfakher/pylot-footer-newsletter'
import {NavigationResponse} from '@pylot-data/hooks/cms/use-cms-blocks'
import {Maybe, CmsBlock} from '@pylot-data/fwrdschema'
import {useStoreConfig} from '@config/hooks/useStoreConfig'
import cn from 'classnames'
import {usePreloadedData} from '@preload'
import {FOOTER_CMS_BLOCKS} from '@config/preload'

const Footer = (): JSX.Element | null => {
    const config = useStoreConfig()
    const {footer: {role} = {}} = config.preload
    const {
        data: {
            cmsBlocks: {items}
        }
    } = (usePreloadedData(FOOTER_CMS_BLOCKS) as unknown) as {
        data: { cmsBlocks: NavigationResponse }
    }

    if (!items || !role) {
        return null
    }

    const mappedItems: Record<string, Maybe<CmsBlock>> = {}
    items.forEach((item) => {
        if (item && item.identifier && item.content) {
            mappedItems[item.identifier] = item
        }
    })

    const handleopenChat = document.getElementById('handlechat')
    if (handleopenChat) {
        const openChatHandler = () => {
            if (window.$zoho && window.$zoho.salesiq) {
                window.$zoho.salesiq.floatwindow.visible('show')
            }
        }

        handleopenChat.addEventListener('click', openChatHandler)
        window.removeEventListener('click', openChatHandler)
    }

    const getBlockOutput = (identifier?: string | null, className?: string) => {
        if (identifier && mappedItems[identifier]) {
            return (
                <div className={className ? s[className] : ''}>
                    <RichContent html={mappedItems[identifier]?.content}/>
                </div>
            )
        }
        return null
    }

    return (
        <footer className={s.footer}>
            <div className={s['footer-value-prop-row']}>
                {getBlockOutput(role.unique)}
            </div>

            <div className={s['footer-container']}>
                <div className={cn(s['grid-rows'], s['social-block'])}>
                    <div id="news-letter" className={s['grid-col-1']}>
                        <Newsletter/>
                    </div>
                    <div className={s['grid-col-2']}>
                        {getBlockOutput('footer-social-media')}
                    </div>
                </div>
                <div className={s['footer-links-block']}>
                    {getBlockOutput(role.links)}
                </div>
                <div className={s['secure-payment']}>
                    {getBlockOutput('footer-secure-payment')}
                </div>
                <div className={s['copyright']}>
                    {getBlockOutput(role.copyright)}
                </div>
            </div>
        </footer>
    )
}

export default Footer
